import React from 'react';

const LISTENER_PAD_WIDTH = 2;

export default function HomeStats({ listeners, bitrate }) {
  return (
    <div className="mt-16 w-full grid grid-cols-3 hairline">
      <div className="p-6 hairline-b md:border-b-0 md:border-r border-white">
        <div className="text-[10px] font-mono-r tracking-[0.4em] uppercase opacity-60">Listeners</div>
        <div className="font-display text-4xl md:text-5xl mt-2">
          {String(listeners).padStart(LISTENER_PAD_WIDTH, '0')}
        </div>
      </div>
      <div className="p-6 hairline-b md:border-b-0 md:border-r border-white">
        <div className="text-[10px] font-mono-r tracking-[0.4em] uppercase opacity-60">Bitrate</div>
        <div className="font-display text-4xl md:text-5xl mt-2">
          {bitrate}
          <span className="text-base ml-1 align-top">k</span>
        </div>
      </div>
      <div className="p-6">
        <div className="text-[10px] font-mono-r tracking-[0.4em] uppercase opacity-60">Hours</div>
        <div className="font-display text-4xl md:text-5xl mt-2">24/7</div>
      </div>
    </div>
  );
}
